import React from "react";
import { renderToString } from 'react-dom/server';
import { Provider } from 'react-redux';
import { store } from 'lib/redux/store';
import { TranslationProvider } from 'features/i18n/TranslationProvider';
import { PDF } from "./PDF";


export default function GetPdfTemplate() : string {
  const template = () : string => renderToString(
      <Provider store={store}>
        <TranslationProvider>
          <PDF />
        </TranslationProvider>
      </Provider>
  );

  return `
<!DOCTYPE html>
<html>

<head>
  <link rel="preconnect" href="https://fonts.googleapis.com">
  <link rel="preconnect" href="https://fonts.gstatic.com" crossorigin>
  <link href="https://fonts.googleapis.com/css2?family=Barlow:ital,wght@0,400;0,500;0,600;1,400;1,500;1,600&display=swap" rel="stylesheet">

  <link href="https://fonts.googleapis.com/css2?family=Bodoni+Moda:ital,wght@0,400;0,500;0,600;1,400;1,500;1,600&display=swap" rel="stylesheet">
  <link href="https://fonts.googleapis.com/css2?family=Poppins:ital,wght@0,200;0,400;0,500;0,600;1,200;1,400;1,500;1,600&display=swap" rel="stylesheet">
  <link href="https://fonts.googleapis.com/css2?family=Montserrat:ital,wght@0,200;0,400;0,500;0,600;1,200;1,400;1,500;1,600&display=swap" rel="stylesheet">
  <link href="https://fonts.googleapis.com/css2?family=Spectral:ital,wght@0,200;0,400;0,500;0,600;1,200;1,400;1,500;1,600&display=swap" rel="stylesheet">
  <link href="https://fonts.googleapis.com/css2?family=Roboto:ital,wght@0,200;0,300;0,400;0,500;0,600;1,200;1,300;1,400;1,500;1,600&display=swap" rel="stylesheet">
  <link href="https://fonts.googleapis.com/css2?family=Roboto+Slab:ital,wght@0,200;0,400;0,500;0,600;1,200;1,400;1,500;1,600&display=swap" rel="stylesheet">
  <link href="https://fonts.googleapis.com/css2?family=Yanone+Kaffeesatz:ital,wght@0,200;0,400;0,500;0,600;1,200;1,400;1,500;1,600&display=swap" rel="stylesheet">
  <link href="https://fonts.googleapis.com/css2?family=Noto+Sans:ital,wght@0,200;0,400;0,500;0,600;1,200;1,400;1,500;1,600&display=swap" rel="stylesheet">

  <link href="https://fonts.googleapis.com/css2?family=Abril+Fatface:ital,wght@0,200;0,400;0,500;0,600;1,200;1,400;1,500;1,600&display=swap" rel="stylesheet">
  <link href="https://fonts.googleapis.com/css2?family=Bitter:ital,wght@0,200;0,400;0,500;0,600;1,200;1,400;1,500;1,600&display=swap" rel="stylesheet">
  <link href="https://fonts.googleapis.com/css2?family=Anton:ital,wght@0,200;0,400;0,500;0,600;1,200;1,400;1,500;1,600&display=swap" rel="stylesheet">
  <link href="https://fonts.googleapis.com/css2?family=Lato:ital,wght@0,150;0,200;0,400;0,500;0,600;1,150;1,200;1,400;1,500;1,600&display=swap" rel="stylesheet">
  <link href="https://fonts.googleapis.com/css2?family=Rochester:ital,wght@0,200;0,400;0,500;0,600;1,200;1,400;1,500;1,600&display=swap" rel="stylesheet">
  <link href="https://fonts.googleapis.com/css2?family=Open+Sans:ital,wght@0,200;0,400;0,500;0,600;1,200;1,400;1,500;1,600&display=swap" rel="stylesheet">
  <link href="https://fonts.googleapis.com/css2?family=Raleway:ital,wght@0,200;0,400;0,500;0,600;1,200;1,400;1,500;1,600&display=swap" rel="stylesheet">
  <link href="https://fonts.googleapis.com/css2?family=Style+Script:ital,wght@0,200;0,400;0,500;0,600;1,200;1,400;1,500;1,600&display=swap" rel="stylesheet">
  <link href="https://fonts.googleapis.com/css2?family=Water+Brush:ital,wght@0,200;0,400;0,500;0,600;1,200;1,400;1,500;1,600&display=swap" rel="stylesheet">

  <link href="https://fonts.googleapis.com/css2?family=Caveat+Brush:ital,wght@0,200;0,400;0,500;0,600;1,200;1,400;1,500;1,600&display=swap" rel="stylesheet">
  <link href="https://fonts.googleapis.com/css2?family=Shadows+Into+Light:ital,wght@0,200;0,400;0,500;0,600;1,200;1,400;1,500;1,600&display=swap" rel="stylesheet">
  <link href="https://fonts.googleapis.com/css2?family=Satisfy:ital,wght@0,200;0,400;0,500;0,600;1,200;1,400;1,500;1,600&display=swap" rel="stylesheet">
  <link href="https://fonts.googleapis.com/css2?family=Caprasimo:ital,wght@0,200;0,400;0,500;0,600;1,200;1,400;1,500;1,600&display=swap" rel="stylesheet">
  <link href="https://fonts.googleapis.com/css2?family=Permanent+Marker:ital,wght@0,200;0,400;0,500;0,600;1,200;1,400;1,500;1,600&display=swap" rel="stylesheet">

  <script src="https://cdn.tailwindcss.com"></script>
  <script>
    tailwind.config = {
      theme: {
        extend: {
          colors: {
            // colors according to figma
            "primary": "#AF1430",
            "secondary": "#AC949E",
            "accent": "#E2AAB5",
            "accent2": "#ECC023",
            "focus": "#2D9CDB",
            "text": "#111111",
            "light-text": "#525252",
            "gray-1": "#A8A8A8",
            "gray-2": "#D8D8D8",
            "gray-3": "#EDEDED",
            "warm-gray": "#F7F4F2",
            "white": "#FFFFFF",
            "green": "#69A61C"
          },
          zIndex: {
            "popover": "20",
            "popover-arrow": "19",
            "modal": "50"
          },
          fontFamily: {
            'fira-sans': ['Fira Sans', 'sans-serif'],
            'barlow': ['Barlow', 'sans-serif']
          },
          dropShadow: {
            'wine-card': '0 0 17px rgba(0,0,0,0.2)',
            'dropdown-menu': '0 0 8px rgba(0,0,0,0.2)'
          },
          spacing: {
            "a4-width": "210mm",
            "a4-height": "296.75mm",
            "a4-page-margin-y": "20mm",
            "a4-page-margin-x": "20mm",
    
            "a4-half-width": "105mm",
            "a4-half-height": "296.75mm",
            "a4-half-page-margin-y": "20mm",
            "a4-half-page-margin-x": "5mm",
            
            "a5-width": "148mm",
            "a5-height": "209.75mm",
            "a5-page-margin-y": "10mm",
            "a5-page-margin-x": "10mm",

            "a6-width": "90mm",
            "a6-height": "134.75mm",
            "a6-page-margin-y": "5mm",
            "a6-page-margin-x": "5mm",
          },
          fontSize: {
            '2xs': '.625rem',
            '3xs': '.5rem'
          },
        },
      },
      plugins: [],
    }    
  </script>
  <style>
    body {
      margin: 0;
      font-family: 'Barlow', sans-serif;
      -webkit-font-smoothing: antialiased;
      -moz-osx-font-smoothing: grayscale;
    }
  </style>
</head>

<body>
  ${template()}
</body>

</html>
`;
}